var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Grid, makeStyles } from '@material-ui/core';
import { VariableIcon } from '@timeflies/app-ui';
import React from 'react';
import { SpellGaugeList } from '../spell-gauge/spell-gauge-list';
import { TimeCounter } from '../time-counter/time-counter';
import { TimeGaugeBig } from '../time-gauge/time-gauge-big';
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette, spacing = _a.spacing;
    return ({
        root: {
            pointerEvents: 'none'
        },
        background: {
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            top: 0,
            opacity: 0.5,
            backgroundColor: palette.background.paper,
            zIndex: -1
        },
        gaugesWrapper: {
            pointerEvents: 'all',
            position: 'relative',
            padding: spacing(1),
            backdropFilter: 'blur(2px)'
        },
        counterWrapper: {
            pointerEvents: 'all',
            position: 'relative',
            minWidth: 56,
            padding: spacing(1, 1.5),
            textAlign: 'center',
            backdropFilter: 'blur(2px)'
        },
        timeGaugeWrapper: {
            backgroundColor: palette.background.default,
            padding: spacing(0.25)
        }
    });
});
export var TimeGaugePanel = function (_a) {
    var startTime = _a.startTime, duration = _a.duration, spellDurationList = _a.spellDurationList;
    var classes = useStyles();
    var timeProps = { startTime: startTime, duration: duration };
    var renderGauges = function () { return (React.createElement(Grid, { item: true, container: true, direction: 'column', xs: true },
        React.createElement(Grid, { item: true },
            React.createElement("div", { className: classes.timeGaugeWrapper },
                React.createElement(TimeGaugeBig, __assign({}, timeProps)))),
        React.createElement(Grid, { item: true },
            React.createElement(SpellGaugeList, __assign({}, timeProps, { spellDurationList: spellDurationList }))))); };
    var background = (React.createElement("div", { className: classes.background }));
    return React.createElement(Grid, { className: classes.root, container: true, direction: 'column', alignItems: 'stretch' },
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement("div", { className: classes.gaugesWrapper },
                background,
                React.createElement(Grid, { container: true, wrap: 'nowrap', spacing: 1 },
                    React.createElement(Grid, { item: true },
                        React.createElement(VariableIcon, { variableName: 'actionTime' })),
                    renderGauges()))),
        React.createElement(Grid, { item: true, style: { alignSelf: 'center' } },
            React.createElement("div", { className: classes.counterWrapper },
                background,
                React.createElement(TimeCounter, __assign({}, timeProps, { colored: true })))));
};
